"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _player = require("../../reducers/player.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Mediator = /*#__PURE__*/function (_React$Component) {
  function Mediator() {
    var _this;
    _classCallCheck(this, Mediator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Mediator, [].concat(args));
    _defineProperty(_this, "state", {
      completedFlows: [],
      hasCompletedAssignment: false
    });
    _defineProperty(_this, "getIncompleteFlows", function () {
      var _this$props = _this.props,
        allowRetake = _this$props.allowRetake,
        flowList = _this$props.flowList,
        isFinalTestMode = _this$props.isFinalTestMode;
      var incompleteFlows = flowList.filter(function (flow) {
        return flow.isComplete === false || flow.completedLocally;
      });
      if (incompleteFlows.length === 0 && (allowRetake || isFinalTestMode) && flowList.length > 0) {
        return flowList;
      }
      return incompleteFlows;
    });
    _defineProperty(_this, "onComplete", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var onComplete;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            onComplete = _this.props.onComplete;
            if (!(onComplete !== null)) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return onComplete();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "onAlreadyComplete", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var onAlreadyComplete;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            onAlreadyComplete = _this.props.onAlreadyComplete;
            if (!(onAlreadyComplete !== null)) {
              _context2.n = 1;
              break;
            }
            _context2.n = 1;
            return onAlreadyComplete();
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "onFlowComplete", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(index) {
        var _this$props2, onFlowStarted, onFlowComplete, incompleteFlows, finishingFlow, finishingProgressBarHandle;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this$props2 = _this.props, onFlowStarted = _this$props2.onFlowStarted, onFlowComplete = _this$props2.onFlowComplete;
              incompleteFlows = _this.getIncompleteFlows();
              finishingFlow = incompleteFlows[index];
              if (!(onFlowComplete !== null)) {
                _context4.n = 1;
                break;
              }
              _context4.n = 1;
              return onFlowComplete(finishingFlow);
            case 1:
              finishingProgressBarHandle = "".concat(finishingFlow.handle, "_").concat(finishingFlow.pawnId);
              _this.props.setProgressBarStatus({
                handle: finishingProgressBarHandle,
                status: 'completed'
              });

              // This Promise ensures that <Playlist /> will wait
              // until all of this is finished before showing the next flow
              return _context4.a(2, new Promise(function (resolve, rej) {
                _this.setState({
                  completedFlows: [].concat(_toConsumableArray(_this.state.completedFlows), [index])
                }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                  var nextFlow, nextProgressBarHandle;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        _context3.n = 1;
                        return _this.tryCompleteAssignment();
                      case 1:
                        resolve();

                        // user can move see the next flow now
                        if (!(index + 1 < incompleteFlows.length)) {
                          _context3.n = 2;
                          break;
                        }
                        nextFlow = incompleteFlows[index + 1];
                        nextProgressBarHandle = "".concat(nextFlow.handle, "_").concat(nextFlow.pawnId);
                        _this.props.setProgressBarCurrent(nextProgressBarHandle);
                        _this.props.setProgressBarStatus({
                          handle: nextProgressBarHandle,
                          status: 'started'
                        });
                        if (!(onFlowStarted !== null)) {
                          _context3.n = 2;
                          break;
                        }
                        _context3.n = 2;
                        return onFlowStarted(nextFlow);
                      case 2:
                        return _context3.a(2);
                    }
                  }, _callee3);
                })));
              }));
          }
        }, _callee4);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "packageFlows", function () {
      return _this.getIncompleteFlows().map(function (flow, index) {
        var packagedFlow = Object.assign({}, flow);
        packagedFlow.onComplete = _this.onFlowComplete.bind(_this, index);
        var keysToOmit = ['flowSettings', 'isComplete', 'isStarted', 'progressBarGroup', 'showIfOption', 'surveySettings'];

        // Start completed flow from the beginning
        if (packagedFlow.isComplete) {
          packagedFlow.pageFirstElementId = 0;
        }
        packagedFlow = (0, _omit2["default"])(packagedFlow, keysToOmit);
        return packagedFlow;
      });
    });
    _defineProperty(_this, "tryCompleteAssignment", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var onAssignmentComplete, _this$state, completedFlows, hasCompletedAssignment, incompletedRequired;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            onAssignmentComplete = _this.props.onAssignmentComplete;
            _this$state = _this.state, completedFlows = _this$state.completedFlows, hasCompletedAssignment = _this$state.hasCompletedAssignment;
            if (!(!onAssignmentComplete || hasCompletedAssignment)) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            incompletedRequired = _this.getIncompleteFlows().filter(function (flow, index) {
              return flow.isRequired !== false && completedFlows.indexOf(index) === -1;
            });
            if (!(incompletedRequired.length === 0)) {
              _context5.n = 3;
              break;
            }
            _context5.n = 2;
            return onAssignmentComplete();
          case 2:
            _this.setState({
              hasCompletedAssignment: true
            });
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    })));
    return _this;
  }
  _inherits(Mediator, _React$Component);
  return _createClass(Mediator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
        onFlowStarted = _this$props3.onFlowStarted,
        onStarted = _this$props3.onStarted;
      if (onStarted !== null) {
        onStarted();
      }
      var incompleteFlows = this.getIncompleteFlows();
      if (onFlowStarted !== null) {
        if (incompleteFlows.length > 0) {
          // TODO: flow by ID instead of handle
          var firstFlow = incompleteFlows[0];
          onFlowStarted(firstFlow);
          var progressBarHandle = "".concat(firstFlow.handle, "_").concat(firstFlow.pawnId);
          this.props.setProgressBarCurrent(progressBarHandle);
          this.props.setProgressBarStatus({
            handle: progressBarHandle,
            status: 'started'
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        flowList = _this$props4.flowList,
        isFinalTestMode = _this$props4.isFinalTestMode,
        isNetworkError = _this$props4.isNetworkError;
      var packagedFlows = this.packageFlows();
      if (packagedFlows.length === 0) {
        if (flowList.length > 0 && !flowList.find(function (f) {
          return f.completedLocally;
        })) {
          this.onAlreadyComplete();
        }
        this.onComplete();
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Playlist, {
        flows: packagedFlows,
        onComplete: this.onComplete,
        isFinalTestMode: isFinalTestMode,
        isNetworkError: isNetworkError
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(Mediator, "propTypes", {
  flowList: _propTypes["default"].array.isRequired,
  onFlowStarted: _propTypes["default"].func,
  onFlowComplete: _propTypes["default"].func,
  onStarted: _propTypes["default"].func,
  onComplete: _propTypes["default"].func,
  onAssignmentComplete: _propTypes["default"].func,
  onAlreadyComplete: _propTypes["default"].func,
  allowRetake: _propTypes["default"].bool,
  isFinalTestMode: _propTypes["default"].bool,
  isNetworkError: _propTypes["default"].bool,
  // From redux
  setProgressBarCurrent: _propTypes["default"].func,
  setProgressBarStatus: _propTypes["default"].func
});
_defineProperty(Mediator, "defaultProps", {
  onFlowStarted: null,
  onFlowComplete: null,
  onStarted: null,
  onComplete: null,
  onAssignmentComplete: null,
  onAlreadyComplete: null,
  allowRetake: false,
  isFinalTestMode: false
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {};
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  setProgressBarCurrent: _player.setProgressBarCurrent,
  setProgressBarStatus: _player.setProgressBarStatus
})(Mediator);